import { createSelector } from "reselect";

import { IStoreState } from "interfaces/storeState";
import { AgentSelectorsNames } from "store/entities/agents";
import { EmailDomainSelectorsNames, selectAreMailboxesSetUp } from "store/entities/email-domains";
import { selectIsManagedByShopify, selectIsShopifyTrial } from "store/entities/integrations";
import { LicenseSelectorsNames, selectIsCompanyNameSet } from "store/entities/license";
import { selectCanInviteAgents } from "store/features/session";
import { createRequestFetchingSelector } from "store/requests/selectors";

import { IPartialInvitePayload } from "./interfaces";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IWelcomeTutorialViewState } from "./reducer";

export interface IWithWelcomeTutorialViewState {
  views: {
    welcomeTutorial: IWelcomeTutorialViewState;
  };
}

export const getIsUpdatingCompanyName = (state: IStoreState): boolean =>
  createRequestFetchingSelector([LicenseSelectorsNames.SET_COMPANY_NAME.UPDATE])(state);

export const getIsCreatingMailbox = (state: IStoreState): boolean =>
  createRequestFetchingSelector([EmailDomainSelectorsNames.CREATE])(state);

export const getIsInvitingAgents = (state: IStoreState): boolean =>
  createRequestFetchingSelector([AgentSelectorsNames.CREATE_BATCH])(state);

export const areForwardingInstructionsSending = (state: IStoreState): boolean =>
  createRequestFetchingSelector([LicenseSelectorsNames.SEND_FORWARDING_INSTRUCTIONS])(state);

export const areForwardingInstructionsSent = (state: IStoreState): boolean =>
  createRequestFetchingSelector([LicenseSelectorsNames.SEND_FORWARDING_INSTRUCTIONS])(state, true);

export const getPartialInvite = (state: IStoreState): IPartialInvitePayload =>
  state.views.welcomeTutorial.partialInvite;

export const getKeepWelcomeTutorialOpened = (state: IStoreState): boolean =>
  state.views.welcomeTutorial.keepWelcomeTutorialOpened;

export const selectSkipStandaloneAppTutorialInviteTeammatesStep = createSelector(
  selectCanInviteAgents,
  selectIsManagedByShopify,
  selectIsShopifyTrial,
  (canInviteAgents, isManagedByShopify, isShopifyTrial) => !canInviteAgents || (isManagedByShopify && !isShopifyTrial)
);

export const selectSkipStandaloneAppTutorialForwardingStep = createSelector(
  selectAreMailboxesSetUp,
  areMailboxesSetUp => areMailboxesSetUp
);

export const selectSkipStandaloneAppTutorial = createSelector(
  selectSkipStandaloneAppTutorialForwardingStep,
  selectSkipStandaloneAppTutorialInviteTeammatesStep,
  selectIsCompanyNameSet,
  (skipForwardingStep, skipInviteTeammatesStep, isCompanyNameSet) =>
    skipForwardingStep && skipInviteTeammatesStep && isCompanyNameSet
);
